import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import axios from "axios";
import {links} from "../../../../utils/links";
import {GridActionsCellItem, GridRowId} from "@mui/x-data-grid";
import React from "react";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {Change, status} from "../../../../global/interfaces/Change";


const RejectActionCell = (props: {id: GridRowId}) => {

    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: (id: GridRowId) => {
            const local_jwt = localStorage.getItem("jwt");
            const headers = {Authorization: `Bearer ${local_jwt}`};
            return axios.put(`${links.rejectAenderung}${id}`, {}, { headers });
        },
        onSuccess: () => {
            queryClient.setQueryData(['Changes'], (oldData: Change[] | undefined) => {
                if (oldData) {
                    return oldData.map((change: Change) =>
                        change.id === props.id ? {...change, status: status.REJECTED} : change
                    );
                }
            });
        }

    })

    return (
        <GridActionsCellItem
            label="Ablehnen"
            icon={<RemoveCircleOutlineIcon color="error"/>}
            onClick={() => mutation.mutate(props.id)}
        />
    )
}

export default RejectActionCell;